export function ceiling(n: number, pos: number) {
  const digits = Math.pow(10, pos);
  const num = Math.ceil(n * digits) / digits;
  return Number(num.toFixed(pos));
}
